<template>
  <v-row class="ma-2">
    <v-autocomplete
      v-model="developmentSelected"
      :items="developmentList"
      :item-text="'name'"
      :item-value="'code'"
      label="Desarrollo Seleccionado"
      @change="handleDevelopmentChange(developmentSelected)"
      hide-details
    >
      <template v-slot:selection="{ item }">
        {{ item.name }}
        <div v-if="item.favorite">
          <v-icon style="margin-left: 5px" size="24" color="orange">
            mdi-star</v-icon
          >
        </div>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-icon>
          <div v-if="item.favorite">
            <v-icon size="24" color="orange"> mdi-star</v-icon>
          </div>
        </v-list-item-icon>
      </template>
    </v-autocomplete>
    <v-spacer></v-spacer>
    <v-text-field
      dense
      rounded
      filled
      v-model="searchTextFilter"
      append-icon="mdi-magnify"
      label="Buscar..."
      single-line
      hide-details
    ></v-text-field>
  </v-row>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "SearchPropertys",
  props: { developmentList: Array },
  data() {
    return { developmentSelected: null };
  },
  watch: {
    developmentList(newList) {
      if (newList.length > 0 && !this.developmentSelected) {
        this.developmentSelected = newList[0];
      }
    }
  },
  computed: {
    ...mapState("properties", ["filterText"]),
    searchTextFilter: {
      get() {
        return this.filterText;
      },
      set(value) {
        this.changeFilterText(value);
      }
    }
  },
  methods: {
    ...mapActions("properties", ["changeFilterText"]),
    handleDevelopmentChange(value) {
      this.developmentSelected = value;
      this.$emit("developmentSelected", value);
    }
  }
};
</script>
